// extracted by mini-css-extract-plugin
module.exports = {"small":"only screen and (min-width: 576px)","breadcrumbs":"_2xSzZ","breadcrumb":"bV5lb"};